import React from 'react'
import { Tabs } from 'antd'
import { useFetchConceptualLabelUsageQuery } from '../../../../../store/apis/conceptual-label.api'
import EditConceptualLabelForm from './EditConceptualLabelForm'
import ConceptualLabelUsageTab from './ConceptualLabelUsageTab'

const EditConceptualLabelTabs = ({ canEdit, conceptualLabel, onSuccess }) => {
    // Fetch usage data for the tab label
    const { data: usageData } = useFetchConceptualLabelUsageQuery(
        { conceptualLabelId: conceptualLabel?.id },
        { skip: !conceptualLabel?.id }
    )

    const tabItems = [
        {
            key: 'edit',
            label: canEdit ? 'Edit' : 'View',
            children: <EditConceptualLabelForm onSuccess={onSuccess} />
        },
        {
            key: 'usage',
            label: `Usage${usageData?.totalUsage > 0 ? ` (${usageData.totalUsage})` : ''}`,
            children: <ConceptualLabelUsageTab conceptualLabelId={conceptualLabel?.id} />
        }
    ]

    return (
        <Tabs 
            items={tabItems}
            defaultActiveKey="edit"
            size="small"
            style={{ marginTop: '-16px' }}
        />
    )
}

export default EditConceptualLabelTabs
